module.exports = "/images/font-awesome-check-circle.png?fde9f8b0ab771ad4e9bc8d18429a8ac7";